import {
    LOGOUT_SUCCESS,
    TOKEN_EXPIRED,
    GET_ADMIN_LIST_REQUEST,
    GET_ADMIN_LIST_SUCCESS,
    GET_ADMIN_LIST_FAILURE,
    GET_ADMIN_ROLE_LIST_REQUEST,
    GET_ADMIN_ROLE_LIST_SUCCESS,
    GET_ADMIN_ROLE_LIST_FAILURE,
    ADD_ADMIN_REQUEST,
    ADD_ADMIN_SUCCESS,
    ADD_ADMIN_FAILURE,
    EDIT_ADMIN_REQUEST,
    EDIT_ADMIN_SUCCESS,
    EDIT_ADMIN_FAILURE,
    REFRESH_TOKEN_REQUEST,
    REFRESH_TOKEN_SUCCESS,
    REFRESH_TOKEN_FAILURE,
    CHANGE_PASSWORD_REQUEST,
    CHANGE_PASSWORD_SUCCESS,
    CHANGE_PASSWORD_FAILURE,
    DELETE_ADMIN_REQUEST,
    DELETE_ADMIN_SUCCESS,
    DELETE_ADMIN_FAILURE,
} from '../constant/actionTypes';
import * as R from 'ramda';

const initState = {
    isLogged: !R.isNil(sessionStorage.getItem('t')),
    tokenExpired: false,
    refreshFailed: false,
    validateStatus: '',
    me: JSON.parse(sessionStorage.getItem('u')) || {},
    roles: [],
    list: {
        isLoading: false,
        pagination: {},
        data: []
    },
    submitResponse: {
        isSubmitting: false,
        data: {}
    },
    user: {}
};

const admin = (state = initState, action) => {
    switch (action.type) {

        case REFRESH_TOKEN_REQUEST:
            return {
                ...state,
                me: {},
                submitResponse: {
                    data: {},
                    isSubmitting: true
                }
            };
        case REFRESH_TOKEN_SUCCESS:
            return {
                ...state,
                tokenExpired: false,
                refreshFailed: false
            };
        case REFRESH_TOKEN_FAILURE:
            return {
                ...state,
                isLogged: false,
                tokenExpired: true,
                refreshFailed: true
            };
        case LOGOUT_SUCCESS:
            return {
                ...initState,
                isLogged: false
            };
        case GET_ADMIN_LIST_REQUEST:
            return {
                ...state,
                list: {
                    data: [],
                    pagination: {},
                    isLoading: true
                }
            };
        case GET_ADMIN_LIST_SUCCESS:
            return {
                ...state,
                list: {
                    data: action.payload.data,
                    pagination: action.payload.pagination,
                    isLoading: false
                }
            };
        case GET_ADMIN_LIST_FAILURE:
            return {
                ...state,
                tokenExpired: action.payload.tokenExpired,
                list: {
                    data: [],
                    pagination: {},
                    isLoading: false
                }
            };
        case GET_ADMIN_ROLE_LIST_REQUEST:
            return {
                ...state,
                roles: []
            };
        case GET_ADMIN_ROLE_LIST_SUCCESS:
            return {
                ...state,
                roles: action.payload
            };
        case GET_ADMIN_ROLE_LIST_FAILURE:
            return {
                ...state,
                tokenExpired: action.payload.tokenExpired,
                roles: []
            };
        case ADD_ADMIN_REQUEST:
        case EDIT_ADMIN_REQUEST:
        case DELETE_ADMIN_REQUEST:
        case CHANGE_PASSWORD_REQUEST:
            return {
                ...state,
                submitResponse: {
                    data: {},
                    isSubmitting: true
                }
            };
        case ADD_ADMIN_SUCCESS:
        case ADD_ADMIN_FAILURE:
        case EDIT_ADMIN_SUCCESS:
        case EDIT_ADMIN_FAILURE:
        case DELETE_ADMIN_SUCCESS:
        case DELETE_ADMIN_FAILURE:
        case CHANGE_PASSWORD_SUCCESS:
        case CHANGE_PASSWORD_FAILURE:
            return {
                ...state,
                submitResponse: {
                    data: action.payload,
                    isSubmitting: false
                }
            };
        case TOKEN_EXPIRED:
            return {
                ...state,
                tokenExpired: true
            };
        default:
            return state;
    }
}

export default admin;
